import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { EGalleryLabelColor, IGalleryLabel } from '../../types/gallery-label';
import { isSuburban } from './category/isSuburban';
import { getAgentListsLabels } from './labels/getAgentListsLabels';
import { getOfferPromoLabels } from './labels/getOfferPromoLabels';
import { getOfferRankingLabels } from './labels/getOfferRankingLabels';
import { getOfferSavedSearchLabels } from './labels/getOfferSavedSearchLabels';

export const mediaLabels: TComputedPropMapper<IGalleryLabel[]> = (props, ctx) => {
  const { offer, withAuction, villagePromotionLabel } = props;

  let labels: IGalleryLabel[] = [];

  if (isSuburban(offer)) {
    const { villageMortgageAllowed } = offer;

    const promotion = (offer.kp?.promotions || [])[0];
    if (villagePromotionLabel && promotion) {
      return [
        {
          color: EGalleryLabelColor.Orange,
          customColor: promotion.color,
          label: promotion.name,
          iconUrl: promotion.labelPromoLogoUrl,
        },
      ];
    }

    if (villageMortgageAllowed) {
      return [
        {
          color: EGalleryLabelColor.Orange,
          label: 'Сельская ипотека 3%',
        },
      ];
    }
  }

  if (!offer.user?.agentLists && !!offer.user && !!offer.user.bank && !withAuction) {
    labels.push({ label: 'Залоговая недвижимость', color: EGalleryLabelColor.LightGrey } as IGalleryLabel);
  }

  if (!offer.user?.agentLists && withAuction) {
    labels.push({ label: 'Залоговая недвижимость, аукцион', color: EGalleryLabelColor.LightGrey } as IGalleryLabel);
  }

  if (offer.user?.agentLists) {
    labels = [...labels, ...getAgentListsLabels(offer.user?.agentLists, ctx)];
  }

  if (offer.savedSearchLabels) {
    labels = [...labels, ...getOfferSavedSearchLabels(offer.savedSearchLabels)];
  }

  if (offer.promoInfo) {
    labels = [...labels, ...getOfferPromoLabels(offer)];
  }

  if (offer.photoLabels) {
    labels = [...labels, ...getOfferRankingLabels(offer)];
  }

  return labels;
};
